import { MmdCameraAnimationContainer } from "@/Loader/Animation/mmdCameraAnimationContainer";
import { CreateAnimationState } from "./Common/createAnimationState";
/**
 * Mmd runtime camera animation that use animation container of babylon.js
 *
 * An object with mmd animation group and camera binding information
 */
export class MmdRuntimeCameraAnimationContainer {
    /**
     * The animation data
     */
    animation;
    _positionAnimationState;
    _rotationAnimationState;
    _distanceAnimationState;
    _fovAnimationState;
    _camera;
    constructor(animation, camera) {
        this.animation = animation;
        this._positionAnimationState = CreateAnimationState();
        this._rotationAnimationState = CreateAnimationState();
        this._distanceAnimationState = CreateAnimationState();
        this._fovAnimationState = CreateAnimationState();
        this._camera = camera;
    }
    /**
     * Update animation
     * @param frameTime Frame time in 30fps
     */
    animate(frameTime) {
        const animation = this.animation;
        const camera = this._camera;
        camera.target.copyFrom(animation.positionAnimation._interpolate(frameTime, this._positionAnimationState));
        camera.rotation.copyFrom(animation.rotationAnimation._interpolate(frameTime, this._rotationAnimationState));
        camera.distance = animation.distanceAnimation._interpolate(frameTime, this._distanceAnimationState);
        camera.fov = animation.fovAnimation._interpolate(frameTime, this._fovAnimationState);
    }
    /**
     * Bind animation to camera
     * @param animation Animation to bind
     * @param camera Bind target
     * @returns MmdRuntimeCameraAnimationContainer instance
     */
    static Create(animation, camera) {
        return new MmdRuntimeCameraAnimationContainer(animation, camera);
    }
}
/**
 * Create runtime camera animation
 * @param camera Bind target
 * @returns MmdRuntimeCameraAnimationContainer instance
 */
MmdCameraAnimationContainer.prototype.createRuntimeCameraAnimation = function (camera) {
    return MmdRuntimeCameraAnimationContainer.Create(this, camera);
};
